module.exports = __webpack_public_path__ + "step5_M2F_nakagawa_bridal.071dd6d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_M2F_nakagawa_bridal.jpg
// module id = EmJk
// module chunks = 0